// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__hoRWc","location":"Header_location__1h1p8"};